module.exports = __webpack_public_path__ + "static/media/dashboard-off.e9a2b681.svg";